import { axiosPrivate } from "../apis/axios";
import { useEffect } from "react";
import useRefreshToken from "./useRefreshToken";
import { useLocalStorage } from "./useLocalStorage";
import { useNavigate } from "react-router-dom";

const useAxiosPrivate = () => {

    const navigate = useNavigate();
    const refresh = useRefreshToken();

    const [user, setUser] =  useLocalStorage("user", null);
  
    useEffect(() => {
       
        const requestIntercept = axiosPrivate?.interceptors?.request.use(
            config => {
                if (!config.headers['Authorization']) {
                    config.headers['Authorization'] = `Bearer ${ JSON.parse(window.localStorage.getItem('user'))?.api_token}`;
                }
                return config;
            }, (error) => Promise.reject(error)
        );

        const responseIntercept = axiosPrivate?.interceptors?.response.use(
            response => response,
            async (error) => {
                const prevRequest = error?.config;
                if ((error?.response?.status === 403) && !prevRequest?.sent) {
                   
                    prevRequest.sent = true;
                    const newAccessToken = await refresh();
                    prevRequest.headers['Authorization'] = `Bearer ${newAccessToken}`;
                    return axiosPrivate(prevRequest);
                }

                if (error?.response?.status === 401 ) {
                    setUser(null)
                    navigate("/db/login", { replace: true });
                    return Promise.reject(error);
                }

             //   console.log("useAxiosPrivate", error)

                return Promise.reject(error);
            }
        );

        return () => {
            axiosPrivate.interceptors.request.eject(requestIntercept);
            axiosPrivate.interceptors.response.eject(responseIntercept);
        }
    }, [user, refresh])
    return axiosPrivate;
}

export default useAxiosPrivate;